var module = angular.module('octopusApp.environments');

module.directive('azureWebAppEndpoint', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            endpoint: '='
        },
        templateUrl: 'areas/environments/views/endpoints/azure_web_app_endpoint.html'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/endpoints/azure_web_app_endpoint.js
// module id = 7082126929618567
// module chunks = 1